import { useState } from "react";
import PmoShell from "./PmoShell";
import ArchivedProjects from "@/components/ArchivedProjects";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function PmoArchived() {
  const [q, setQ] = useState("");
  return (
    <PmoShell
      title="Archived Projects"
      subtitle="Completed projects preserved as organizational knowledge — restore them or open them read-only for reference."
      testid="pmo-archived-page"
      actions={(
        <div className="relative w-full sm:w-72">
          <Search className="h-4 w-4 text-muted-foreground absolute left-3 top-1/2 -translate-y-1/2" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search archived projects…" className="pl-9" data-testid="pmo-archived-search" />
        </div>
      )}
    >
      <ArchivedProjects search={q} />
    </PmoShell>
  );
}
